import company from "./company";
import companyContact from "./companyContact";
import companyGroup from "./companyGroup";
import container from "./container";
import deliveryPoint from "./deliveryPoint";
import deliveryPointDirective from "./deliveryPointDirective";
import fishingMode from "./fishingMode";
import history from "./history";
import logisticalLot from "./logisticalLot";
import lot from "./lot";
import lotManagementDirective from "./lotManagementDirective";
import parameter from "./parameter";
import productFresh from "./productFreshe";
import productSize from "./productSize";
import productSpecy from "./productSpecy";
import saleType from "./saleType";
import saleTypes from "./SaleTypes";
import status from "./status";
import transportTemplate from "./transportTemplate";
import user from "./user";

export default {
    company,
    companyContact,
    companyGroup,
    container,
    deliveryPoint,
    deliveryPointDirective,
    fishingMode,
    history,
    logisticalLot,
    lot,
    lotManagementDirective,
    parameter,
    productFresh,
    productSize,
    productSpecy,
    saleType,
    saleTypes,
    status,
    transportTemplate,
    user,
};
